import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { Card, CardContent } from "@mui/material";

const chartSetting = {
  yAxis: [
    {
      label: "Sales",
    },
  ],
  width: 500,
  height: 300,
  sx: {
    [`.${axisClasses.left} .${axisClasses.label}`]: {
      transform: "translate(-20px, 0)",
    },
  },
};

type BarsDatasetProps = {
  data: any[]; // Replace 'any' with a more specific type if possible
  xKey: string;
  series: any; // Replace 'any' with a more specific type if possible
  title?: string; // Added title prop
};

export default function BarsDataset({
  data,
  xKey,
  series,
  title,
}: BarsDatasetProps) {
  const theme = useTheme();

  const themedSeries = series.map((s: any) => ({
    ...s,
    color: theme.palette.primary.main,
  }));

  return (
    <>
      <Card>
        <CardContent>
          {title && (
            <Typography variant="h6" component="h2" gutterBottom>
              {title}
            </Typography>
          )}
          <BarChart
            dataset={data}
            xAxis={[{ scaleType: "band", dataKey: xKey }]}
            series={themedSeries}
            {...chartSetting}
          />
        </CardContent>
      </Card>
    </>
  );
}
